import getUrl from "../../../getUrl";

export default function requestPriceList({name, phone, email, subject, company, question}) {
  fetch(getUrl('/cat/v3/mail/send'), {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    method: 'POST',
    credentials: 'include',
    body: JSON.stringify({
      ...(phone && {phone}),
      ...(name && {name}),
      ...(email && {email}),
      ...(subject && {subject}),
      ...(company && {company}),
      ...(question && {question}),
    }),
  });
}


// WEBPACK FOOTER //
// ./src/finwhale/common/price-list-request/requestPriceList.js